import { createServerFn } from "@tanstack/react-start";
import jwt from "jsonwebtoken";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

export const INTERCOM_APP_ID = "byp6r0lc";

export const getIntercomJwt = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const secret = process.env.INTERCOM_JWT_SECRET;
    if (!secret) throw new Error("INTERCOM_JWT_SECRET is not configured");

    const { supabase, userId, claims } = context;

    const { data: profile } = await supabase
      .from("profiles")
      .select("id, email, full_name")
      .eq("id", userId)
      .maybeSingle();

    const email = profile?.email || (claims as { email?: string }).email || "";
    const name = profile?.full_name || email;
    const createdAt = Math.floor(
      new Date(
        (claims as { iat?: number }).iat
          ? ((claims as { iat: number }).iat as number) * 1000
          : Date.now(),
      ).getTime() / 1000,
    );

    const token = jwt.sign(
      {
        user_id: userId,
        email,
        name,
        created_at: createdAt,
      },
      secret,
      { algorithm: "HS256", expiresIn: "1h" },
    );

    return { token, expiresIn: 3600, userId, email, name, createdAt };
  });
